import PropType from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';

import logo from '../../../assets/account_logo.svg';
import styles from './logo.style';

export class Logo extends React.PureComponent {
  static propTypes = {
    classes: PropType.object.isRequired
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.logoBox}>
        <img alt="Stratumn ID" className={classes.logo} src={logo} />
      </div>
    );
  }
}

export default injectSheet(styles)(Logo);
